import { LOADER_STATUS, GROUP_DATA,TOTAL_RECORD } from './constants';
export const initialState = {
    loaderStatus: false,
    groups: [],
    totalRecords: 0,
};
const manageGroupsReducer = (state = initialState, action) =>{
    switch (action.type) {
        case LOADER_STATUS:
            return {
                ...state,
                loaderStatus:action.loaderStatus
            }
        case TOTAL_RECORD:
            return {
                ...state,
                totalRecords:action.totalRecords,
                records:action.records
            }
        default:
            return state; 
    }
}
        

export default manageGroupsReducer;